// Маска из шаблона v-mask: '#' — цифра, любой другой символ — литерал-разделитель.
// Количество '#' задаёт максимум цифр. Пример: '### ### ## ##' -> "702 321 69 96".
const applyMask = (raw, pattern) => {
  const digits = raw.replace(/\D/g, '');
  let out = '';
  let di = 0;
  for (const ch of pattern) {
    if (di >= digits.length) break; // не добавляем «хвостовые» разделители
    out += ch === '#' ? digits[di++] : ch;
  }
  return out;
};

const getInput = (el) => (el.tagName === 'INPUT' ? el : el.querySelector('input'));

export const digitsMask = {
  mounted(el, binding) {
    const input = getInput(el);
    if (!input) return;
    input._maskPattern = binding.value || '';
    input._maskHandler = () => {
      const masked = applyMask(input.value, input._maskPattern);
      if (input.value !== masked) {
        input.value = masked;
        input.dispatchEvent(new Event('input'));
      }
    };
    input.addEventListener('input', input._maskHandler);
    input._maskHandler();
  },
  updated(el, binding) {
    const input = getInput(el);
    if (!input) return;
    input._maskPattern = binding.value || '';
    input._maskHandler?.();
  },
  unmounted(el) {
    const input = getInput(el);
    if (input?._maskHandler) input.removeEventListener('input', input._maskHandler);
  },
};
